import React from "react";
import "../styles/contact.css";
import { FaPhoneAlt, FaEnvelope } from "react-icons/fa";
import Footer from "./Footer"; // adjust path if needed

function ContactPage() {
  return (
    <>
      <section className="contact-wrapper">
        <div className="contact-header">Contact Us</div>
        <h2 className="contact-title">Connect to your goals</h2>
        <p className="contact-description">
          We currently provide services in Melbourne and the surrounding
          suburbs, up to Geelong in the southwest and Mornington Peninsula in
          the far south. Please call us today for services in your area. We will
          make every effort to accommodate you.
        </p>

        <form className="contact-form">
          <div className="form-row">
            <input type="text" placeholder="Your Name" />
            <input type="email" placeholder="Email Address" />
          </div>
          <div className="form-row">
            <input type="tel" placeholder="Phone Number" />
            <input type="text" placeholder="Subject" />
          </div>
          <div className="form-row">
            <textarea placeholder="Write Message" rows="5" />
          </div>
          <button type="submit" className="submit-btn">
            Send a Message
          </button>
        </form>

        <div className="contact-boxes">
          <div className="contact-box">
            <div className="icon-circle">
              <FaPhoneAlt />
            </div>
            <span>+61 426 533 333</span>
          </div>

          <div className="contact-box">
            <div className="icon-circle">
              <FaEnvelope />
            </div>
            <span>info@carenestservicesau.com.au</span>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}

export default ContactPage;
